import { Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Title } from '@angular/platform-browser';
import { TranslocoService } from '@ngneat/transloco';
import { ConfirmationService, MessageService, Message } from 'primeng/api';
import { Table } from 'primeng/table';
import { Status } from 'src/app/model/enum/status';
import { Project } from 'src/app/model/form/project';
import { Vcu } from 'src/app/model/form/vcu';
import { Item } from 'src/app/model/Item';
import { VcuFileItem } from 'src/app/model/response/vcu-files-response';
import { VcuService } from 'src/app/service/vcu.service';
import { ProjectService } from 'src/app/service/project.service';
import { ActivatedRoute, Router } from '@angular/router';
import { VcuAttributes } from 'src/app/model/vcu-attributes';
import { Location } from '@angular/common';
import { Load } from 'src/app/model/mockup/load-mockup';
import { Image } from 'src/app/model/Image';
import { ModelService } from 'src/app/service/model.service';
import { AuthService } from 'src/app/service/auth.service';
import { AccountService } from 'src/app/service/account.service';
import { PlanFeatureService } from 'src/app/service/plan-feature.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CustomValidator } from 'src/shared/custom-validator';
import { FamilyService } from 'src/app/service/family.service';
import { ChangeDetectorRef } from '@angular/core';
import { forkJoin } from 'rxjs';


@Component({
  selector: "app-vcu",
  templateUrl: "./vcu.component.html",
  styleUrl: "./vcu.component.css",
})
export class VcuComponent implements OnInit {
  logs: VcuFileItem[] = [];
  maps: VcuFileItem[] = [];
  vcu!: Vcu;
  projects: Project[];

  originalVcuData: any;

  @ViewChild("dtLog") dtLog: Table | undefined;
  @ViewChild("dtMap") dtMap: Table | undefined;
  loadingLog: boolean = true;
  loadingMap: boolean = true;
  imgClass: string = "";
  cardHeaderClass: string = "";
  subtitleClass: string = "";
  statusClass: string = "";
  statusName: string = "";
  isPending: boolean = false;
  showDialogUnlink: boolean = false;
  showEditVcuDialog: boolean = false;
  reasonUnlinkVcu: string = "";
  projectOptions: Item[] = [];
  availableProjects: Project[] = [];
  selectedProjectId: string | null = null;
  showDialogLink: boolean = false;
  projectLink: Item | null = null;
  projectLinkInvalid: string = "";
  projectUnlinkInvalid: string = "";
  showProjectDialog: boolean = false;
  unlinkVcuBtnLoading: boolean = false;
  token: string | null = "";
  userID: string = "";
  vcuID: string = "";
  messages: Message[] = [];
  vcuProjects: Item[] = [];
  isLoadingProjects: boolean = false;
  modelOptions: Item[] = [];
  familyOptions: Item[] = [];
  idAux: number = 0;
  isDisabled: boolean = false;
  lang: string = "pt-br";
  vcuUrl: string = "";
  isEditingMode: boolean = false;
  public form!: FormGroup;

  /** Modo de edicao da ficha. Antes o estado era deduzido comparando o ROTULO
   *  TRADUZIDO do botao ("Editar VCU" vs "Aplicar Alteracoes") dentro de um
   *  setTimeout com dois selectTranslate aninhados: trocar de idioma no meio da
   *  edicao embaralhava o estado, porque a fonte da verdade era o texto na tela.
   *  Agora o booleano manda e o rotulo e consequencia dele. */
  editMode = false;

  /** Os unicos campos que a edicao abre. `serialNumber` fica de fora: e a
   *  identidade do equipamento, nao um dado editavel. */
  private readonly editableFields = [
    "surname",
    "family",
    "model",
    "invoice",
    "purchaseDate",
    "tags",
  ];
  hasTelemetry: boolean = true;
  showProModal: boolean = false;
  currentPlanId: string | null = null;
  billingType: 'stripe' | 'manual' | null = null;

  constructor(
    private translocoService: TranslocoService,
    private activatedRoute: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private titleService: Title,
    private projectService: ProjectService,
    private vcuService: VcuService,
    private location: Location,
    private router: Router,
    private authService: AuthService,
    private accountService: AccountService,
    private planFeatureService: PlanFeatureService,
    private modelService: ModelService,
    private familyService: FamilyService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
  ) {
    this.vcu = new Vcu();
    //TODO BACKEND solciitar os logs por usuario e id da VCU
    // this.logs = VCU_LOG_LIST;
    //TODO BACKEND solciitar os mapas por usuario e id da VCU
    // this.maps = VCU_MAP_LIST;
    //TODO BACKEND solciitar os projetos por usuario e id da VCU
    this.projects = [];
    this.loadingLog = false;
    this.loadingMap = false;
    this.isLoadingProjects = false;
    this.vcuUrl = "/vcu-management";
    //TODO BACKEND solicitar a lista de manuais e documentos da VCU
  }
  async ngOnInit() {
    // this.userID = sessionStorage.getItem('idUser') ?? '';
    this.userID = this.authService.getUserInformations();
    let language = sessionStorage.getItem("language");
    if (language && language !== null) this.lang = language;
    this.changeLanguage();
    this.setTitle();
    this.createForm(this.vcu);
    this.messageService.clear();
    this.getModelAndFamily();
    this.f.surname.disable();
    window.scrollTo({ top: 0, behavior: "smooth" });
    this.loadPlanFeatures();
  }

  private loadPlanFeatures(): void {
    this.accountService.getAccount(this.userID).subscribe({
      next: (account) => {
        this.planFeatureService.load(account.planInformation);
        this.hasTelemetry = this.planFeatureService.hasFeature('Telemetry');
        this.currentPlanId = this.planFeatureService.planId;
        this.billingType = this.planFeatureService.billingType;
      },
      error: () => {
        this.hasTelemetry = false;
      }
    });
  }

  getVcu() {
    this.activatedRoute.params.subscribe((params) => {
      this.vcuID = decodeURIComponent(params["id"]);
      this.vcuService.setVcuID(this.vcuID);
      this.isLoadingProjects = true;
      this.vcuService.getVcu().subscribe({
        next: (response) => {
          if (response && response.length > 0) {
            this.vcu = VcuService.userVcuToVcu(response[0]);
            if (this.vcu.vcuAttributes?.model) {
              let nameModel = this.modelOptions.filter(
                (model) => model.id === this.vcu.vcuAttributes?.model
              );
              if (nameModel.length > 0) {
                this.vcu.model = new Item(
                  this.vcu.vcuAttributes?.model,
                  nameModel[0].name
                );
              }
            }
            this.setTitle(this.vcu.surname);
            this.vcu.status === Status.DISABLED
              ? (this.isDisabled = true)
              : (this.isDisabled = false);
            this.vcuStatusVerify();
            this.removeProjectsDI();
            this.isLoadingProjects = false;
            this.createForm(this.vcu);
            this.loadVcuFiles();
          }
        },
        error: (_) => {
          this.isLoadingProjects = false;
        },
      });
    });
  }

  /** Carrega arquivos de mapas e logs da VCU (tb_user_file) via API. */
  loadVcuFiles(): void {
    if (!this.userID || !this.vcuID) return;
    this.loadingMap = true;
    this.loadingLog = true;
    this.vcuService.getUserFiles(this.userID, { vcuID: this.vcuID, type: 'map', page: 1, pageItens: 50 }).subscribe({
      next: (res) => {
        this.maps = res?.listItens ?? [];
        this.loadingMap = false;
      },
      error: () => {
        this.maps = [];
        this.loadingMap = false;
      },
    });
    this.vcuService.getUserFiles(this.userID, { vcuID: this.vcuID, type: 'log', page: 1, pageItens: 50 }).subscribe({
      next: (res) => {
        this.logs = res?.listItens ?? [];
        this.loadingLog = false;
      },
      error: () => {
        this.logs = [];
        this.loadingLog = false;
      },
    });
  }

  vcuStatusVerify() {
    if (this.vcu !== undefined) {
      if (this.vcu.status == Status.ACTIVE) {
        this.statusClass = "status-green";
        this.translocoService
          .selectTranslate("vcu.status.ac")
          .subscribe((value) => (this.statusName = value))
          .unsubscribe();
      } else if (this.vcu.status == Status.ACTIVATION_PENDING) {
        this.imgClass = "img-pending";
        this.cardHeaderClass = "card-header-pending";
        //this.subtitleClass = 'subtitle-pending';
        //this.isPending = true;
        this.statusClass = "status-yellow";
        this.translocoService
          .selectTranslate("vcu.status.ap")
          .subscribe((value) => (this.statusName = value))
          .unsubscribe();
      } else if (this.vcu.status == Status.DISABLED) {
        this.statusClass = "status-red";
        this.translocoService
          .selectTranslate("vcu.status.di")
          .subscribe((value) => (this.statusName = value))
          .unsubscribe();
      }
      this.idAux += 1;
      this.vcuService.vcuImage(this.idAux, this.vcu).subscribe((img) => {
        if (this.vcu) {
          this.vcu.image = img;
        }
      });
    }
  }

  removeProjectsDI() {
    this.vcu.projects = this.vcu.projects.filter(
      (proj) => proj.status !== Status.DISABLED
    );
  }

  formatImage(image: string | undefined | null) {
    if (image) return "url(" + image + ")";
    return "";
  }

  /** Abre a edicao guardando o estado atual, para o Cancelar poder voltar. */
  startEdit(): void {
    this.originalVcuData = this.editableFields.reduce((acc, field) => {
      acc[field] = this.f[field]?.value;
      return acc;
    }, {} as any);
    this.editableFields.forEach((field) => this.f[field]?.enable());
    this.editMode = true;
  }

  /** Grava so se algo mudou de fato e volta pra leitura. */
  saveEdit(): void {
    const hasChanges = this.editableFields.some(
      (field) => this.f[field]?.value !== this.originalVcuData[field]
    );
    if (hasChanges) {
      this.updateVcu();
    }
    this.editableFields.forEach((field) => this.f[field]?.disable());
    this.editMode = false;
  }

  /** Descarta o que foi digitado. Antes nao existia saida da edicao: o segundo
   *  clique no botao sempre salvava, entao entrar era caminho sem volta. */
  cancelEdit(): void {
    this.editableFields.forEach((field) => {
      this.f[field]?.setValue(this.originalVcuData?.[field] ?? null);
      this.f[field]?.disable();
    });
    this.editMode = false;
  }

  copySerial(): void {
    const serial = this.vcu?.serialNumber;
    if (!serial) return;
    navigator.clipboard.writeText(serial).then(() => {
      this.showMessage("success", this.translocoService.translate("messages.info.copied"));
    });
  }

  /* ── Valores do modo leitura ────────────────────────────────────────
     Devolvem null quando vazio, para o template exibir "—". O problema antigo
     era exatamente aqui: input desabilitado e vazio renderiza o PLACEHOLDER, de
     modo que "Nota Fiscal" e "Data da Compra" pareciam valores preenchidos. */

  /** Le do form, nao de `vcu.surname`: depois de salvar o objeto so troca
   *  quando a resposta HTTP chega, e o titulo piscaria com o nome antigo. */
  get readSurname(): string {
    return this.form?.get("surname")?.value || "";
  }

  get readFamily(): string | null {
    return this.form?.get("family")?.value?.name || null;
  }

  get readModel(): string | null {
    return this.form?.get("model")?.value?.name || null;
  }

  get readInvoice(): string | null {
    return this.form?.get("invoice")?.value || null;
  }

  get readPurchaseDate(): Date | string | null {
    return this.form?.get("purchaseDate")?.value || null;
  }

  get readTags(): string[] {
    return this.form?.get("tags")?.value || [];
  }

  closeVcuDialog() {
    this.showEditVcuDialog = false;
    this.getVcu();

  }

  dialogUnlink() {
    this.projectUnlinkInvalid = "";
    this.messages = [];
    this.showDialogUnlink = true;
  }

  deleteVcu() {
    this.translocoService
      .selectTranslateObject("vcu.remove")
      .subscribe((value) =>
        this.confirmationService.confirm({
          message: value.message,
          header: value.header,
          icon: "pi pi-info-circle",
          acceptButtonStyleClass: "p-button-danger",
          rejectButtonStyleClass: "p-button-text",
          acceptLabel: value.yes,
          rejectLabel: value.no,
          acceptIcon: "none",
          rejectIcon: "none",
          accept: () => {
            this.vcu.status = Status.DISABLED;
            this.vcuService.deleteVcuNoProject().subscribe({
              next: (_) => {
                this.getVcu();
                this.messageService.clear();
                this.translocoService
                  .selectTranslate("vcu.remove.success")
                  .subscribe((value) => {
                    this.messageService.add({
                      key: "toastVcu",
                      severity: "success",
                      summary: value,
                    });
                  })
                  .unsubscribe();
                this.router.navigate([this.vcuUrl]);
              },
              error: (_) => {
                this.messageService.clear();
                this.translocoService
                  .selectTranslate("errorConection")
                  .subscribe((value) => this.showMessage("error", value));
              },
            });
          },
          reject: () => {},
        })
      )
      .unsubscribe();
  }

  unlinkVCU() {
    if (this.reasonUnlinkVcu && this.reasonUnlinkVcu !== "") {
      if (!this.vcu.vcuAttributes) {
        this.vcu.vcuAttributes = new VcuAttributes();
      }
      this.unlinkVcuBtnLoading = true;
      this.vcu.vcuAttributes.reasonUnlink = this.reasonUnlinkVcu;
      this.vcuService.updateVcu(this.vcu).subscribe((updated) => {
        this.vcuService.unlinkVcuInProject().subscribe({
          next: (_) => {
            this.messages = [];
            this.messageService.clear();
            this.translocoService
              .selectTranslateObject("vcu.detail.unlinkVcu")
              .subscribe((value) => {
                this.messageService.add({
                  key: "toastVcu",
                  severity: "success",
                  summary: value.header,
                  detail: value.msgSuccess,
                });
              })
              .unsubscribe();
            setTimeout(() => {
              this.unlinkVcuBtnLoading = false;
              this.showDialogUnlink = false;
              this.location.back();
            }, 3000); //3s
          },
          error: (_) => {
            this.messages = [];
            this.unlinkVcuBtnLoading = false;
            this.translocoService
              .selectTranslate("errorConection")
              .subscribe((value) => this.showMessage("error", value))
              .unsubscribe();
          },
        });
      });
    } else {
      this.projectUnlinkInvalid = "ng-dirty ng-invalid";
      this.translocoService
        .selectTranslate("inputRequired")
        .subscribe((value) => this.showMessage("error", value))
        .unsubscribe();
    }
  }

  refreshListProjects() {
    this.getVcu();
  }

  linkToProject() {
    this.userID = this.authService.getUserInformations();
    this.projectService
      .findAllProjectSummary(this.userID, "AC")
      .subscribe((data) => {
        let projOptions: Item[] = [];
        let filteredProjects: Project[] = [];
        let projects: Project[] =
          this.projectService.projectSummaryToProject(data);
        if (this.vcu.projects) {
          for (let project of projects) {
            if (
              this.vcu.projects.filter((proj) => proj.id === project.id)
                .length === 0
            ) {
              projOptions.push(new Item(project.id, project.name));
              filteredProjects.push(project);
            }
          }
          this.projectOptions = [...projOptions];
          this.availableProjects = [...filteredProjects];
          this.selectedProjectId = null;
          this.projectLink = null;
          this.showDialogLink = true;
        }
      });
  }

  selectProjectCard(project: Project) {
    this.selectedProjectId = project.id;
    this.projectLink = new Item(project.id, project.name);
    this.projectLinkInvalid = '';
  }

  getProjectCardImage(project: Project): string {
    return this.projectService.setImageCard(project, this.userID);
  }

  linkVCU() {
    //TODO BACKEND vincular VCU ao Projeto this.form.value -> garageLink.id
    if (this.vcu && this.projectLink) {
      this.vcuService.setVcuID(this.vcu.id);
      this.vcuService.setProjectID(this.projectLink.id + "");
      this.vcuService.linkVcuInProject().subscribe({
        next: (_) => {
          this.messageService.clear();
          this.translocoService
            .selectTranslateObject("vcu.detail.linkVcu")
            .subscribe((value) => {
              this.messageService.add({
                key: "toastVcu",
                severity: "success",
                summary: value.header,
                detail: value.msgSuccess,
              });
            })
            .unsubscribe();
          this.showDialogLink = false;
          this.getVcu();
        },
        error: (_) => {
          this.messages = [];
          this.translocoService
            .selectTranslate("errorConection")
            .subscribe((value) => this.showMessage("error", value))
            .unsubscribe();
        },
      });
    } else {
      this.projectLinkInvalid = "ng-dirty ng-invalid";
    }
  }

  newProject() {
    //TODO Chamar cadastro do projeto
    // Garantir que o dialog está fechado antes de abrir novamente
    this.showProjectDialog = false;
    setTimeout(() => {
      this.showProjectDialog = true;
    }, 0);
  }

  updateProjectDialog(eventProjectID: string) {
    if (eventProjectID) {
      this.vcuService.setVcuID(this.vcuID);
      this.vcuService.setProjectID(eventProjectID);
      this.vcuService.linkVcuInProject().subscribe();
    }
    this.showProjectDialog = false;
    this.getVcu();
  }

  /** Chamado pelo explorador de arquivos para excluir (abre o mesmo diálogo de confirmação). */
  onExplorerDeleteFile(payload: { type: 'map' | 'log'; index: number; file: VcuFileItem }): void {
    if (payload.type === 'log') {
      this.onRowRemoveLog({ target: document.body } as any, payload.index);
    } else {
      this.onRowRemoveMap({ target: document.body } as any, payload.index);
    }
  }

  /** Download de arquivo (mapa ou log) com suporte a chunking para arquivos grandes. */
  onRowDownload(type: 'map' | 'log', index: number): void {
    const list = type === 'map' ? this.maps : this.logs;
    const file = list[index];
    if (!file?.id || !this.userID || !this.vcuID) return;

    const folder = type === 'map' ? 'map' : 'log';
    const fileName = file.fileName ?? `${type}_${file.id}`;
    const chunkSize = 10483712; // 10 MB

    this.vcuService.downloadVcuFile(this.userID, this.vcuID, folder, file.id, 0, chunkSize)
      .subscribe({
        next: async (response) => {
          const contentRange = response.headers.get('Content-Range');
          const totalSize = contentRange ? parseInt(contentRange.split('/')[1], 10) : 0;
          const blobs: Blob[] = [response.body as Blob];

          if (totalSize > chunkSize) {
            const totalChunks = Math.ceil(totalSize / chunkSize);
            const promises: Promise<any>[] = [];
            for (let i = 1; i < totalChunks; i++) {
              const start = i * chunkSize + 1;
              const end = (i + 1) * chunkSize;
              promises.push(
                this.vcuService.downloadVcuFile(this.userID, this.vcuID, folder, file.id, start, end).toPromise()
              );
            }
            try {
              const responses = await Promise.all(promises);
              responses.forEach((r) => { if (r?.body) blobs.push(r.body as Blob); });
            } catch {
              this.translocoService.selectTranslate('errorConection').subscribe(msg =>
                this.messageService.add({ key: 'toastVcu', severity: 'error', summary: msg })
              ).unsubscribe();
              return;
            }
          }

          this.downloadBlob(new Blob(blobs, { type: 'application/octet-stream' }), fileName);
        },
        error: (err) => {
          if (err?.status === 404) {
            this.translocoService.selectTranslate('vcu.detail.fileNotFound').subscribe(msg =>
              this.messageService.add({ key: 'toastVcu', severity: 'warn', summary: msg })
            ).unsubscribe();
          } else {
            this.translocoService.selectTranslate('errorConection').subscribe(msg =>
              this.messageService.add({ key: 'toastVcu', severity: 'error', summary: msg })
            ).unsubscribe();
          }
        }
      });
  }

  private downloadBlob(blob: Blob, fileName: string): void {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => window.URL.revokeObjectURL(url), 200);
  }

  onRowRemoveLog(event: Event, index: number) {
    const file = this.logs[index];
    if (!file?.id) return;
    this.translocoService
      .selectTranslateObject("vcu.detail.tableLog.delete")
      .subscribe((value) =>
        this.confirmationService.confirm({
          target: event.target as EventTarget,
          message: value.message,
          header: value.header,
          icon: "pi pi-info-circle",
          acceptButtonStyleClass: "p-button-danger",
          rejectButtonStyleClass: "p-button-text",
          acceptLabel: value.yes,
          rejectLabel: value.no,
          acceptIcon: "none",
          rejectIcon: "none",
          accept: () => {
            this.vcuService.deleteVcuFile(this.userID, this.vcuID, 'log', file.id).subscribe({
              next: () => {
                const i = this.logs[index]?.id === file.id ? index : this.logs.findIndex((l) => l.id === file.id);
                if (i >= 0) this.logs.splice(i, 1);
                this.translocoService.selectTranslate("vcu.detail.tableLog.deleteSuccess").subscribe(msg =>
                  this.messageService.add({ key: 'toastVcu', severity: 'success', summary: msg })
                ).unsubscribe();
              },
              error: (err) => this.notifyVcuDeleteError(err),
            });
          },
          reject: () => {},
        })
      )
      .unsubscribe();
  }

  onRowRemoveMap(event: Event, index: number) {
    const file = this.maps[index];
    if (!file?.id) return;
    this.translocoService
      .selectTranslateObject("vcu.detail.tableMap.delete")
      .subscribe((value) =>
        this.confirmationService.confirm({
          target: event.target as EventTarget,
          message: value.message,
          header: value.header,
          icon: "pi pi-info-circle",
          acceptButtonStyleClass: "p-button-danger",
          rejectButtonStyleClass: "p-button-text",
          acceptLabel: value.yes,
          rejectLabel: value.no,
          acceptIcon: "none",
          rejectIcon: "none",
          accept: () => {
            this.vcuService.deleteVcuFile(this.userID, this.vcuID, 'map', file.id).subscribe({
              next: () => {
                const i = this.maps[index]?.id === file.id ? index : this.maps.findIndex((m) => m.id === file.id);
                if (i >= 0) this.maps.splice(i, 1);
                this.translocoService.selectTranslate("vcu.detail.tableMap.deleteSuccess").subscribe(msg =>
                  this.messageService.add({ key: 'toastVcu', severity: 'success', summary: msg })
                ).unsubscribe();
              },
              error: (err) => this.notifyVcuDeleteError(err),
            });
          },
          reject: () => {},
        })
      )
      .unsubscribe();
  }

  private notifyVcuDeleteError(err: unknown): void {
    const status = err instanceof HttpErrorResponse ? err.status : 0;
    const key =
      status === 400 ? 'common.deleteErrors.badRequest'
      : status === 403 ? 'common.deleteErrors.forbidden'
      : status === 404 ? 'common.deleteErrors.notFound'
      : 'common.deleteErrors.generic';
    const severity = status === 404 ? 'warn' : 'error';

    this.translocoService
      .selectTranslate(key)
      .subscribe((msg) =>
        this.messageService.add({ key: 'toastVcu', severity, summary: msg })
      )
      .unsubscribe();
  }

  applyFilterGlobalLog($event: any, stringVal: string) {
    this.dtLog?.filterGlobal(
      ($event.target as HTMLInputElement).value,
      stringVal
    );
  }
  applyFilterGlobalMap($event: any, stringVal: string) {
    this.dtMap?.filterGlobal(
      ($event.target as HTMLInputElement).value,
      stringVal
    );
  }

  setTitle(title?: string) {
    if (title) {
      this.titleService.setTitle("FT Pilot - " + title);
    } else {
      this.translocoService
        .selectTranslate("title.vcu")
        .subscribe((value) => this.titleService.setTitle(value));
    }
  }

  public changeLanguage(languageCode?: string | null): void {
    if (!languageCode || languageCode === null)
      languageCode = sessionStorage.getItem("language");
    if (languageCode && languageCode !== null)
      this.translocoService.setActiveLang(languageCode);
  }

  createForm(vcu: Vcu | null) {
    if (vcu) {
      this.form = this.formBuilder.group({
        id: [vcu.id],
        image: [vcu.image],
        surname: [vcu.surname, CustomValidator.getRequired()],
        family: [vcu.family, CustomValidator.getRequired()],
        model: [vcu.model, CustomValidator.getRequired()],
        serialNumber: [
          { value: vcu.serialNumber, disabled: false },
          CustomValidator.getRequired(),
        ],
        reseller: [vcu.reseller],
        invoice: [vcu.invoice],
        purchaseDate: [vcu.purchaseDate],
        tags: [vcu.tags],
        generalVersionDate: [vcu.generalVersionDate],
        status: [vcu.status],
        lastAcessDate: [vcu.lastAcessDate],
      });
      // createForm e o unico lugar que estabelece o estado dos campos, entao o
      // booleano acompanha aqui — inclusive no recarregamento depois de salvar.
      this.editMode = false;
      this.f.surname.disable();
      this.f.family.disable();
      this.f.model.disable();
      this.f.invoice.disable();
      this.f.purchaseDate.disable();
      this.f.tags.disable();
    }
  }

  get f() {
    return this.form.controls;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.vcu?.currentValue) {
      this.vcu = changes.vcu.currentValue;
      this.familyOptions
        .filter((item) => this.vcu && item.id === this.vcu.family?.id)
        .map((it) => (this.vcu ? (this.vcu.family = it) : null));
      this.modelOptions
        .filter((item) => this.vcu && item.id === this.vcu.model?.id)
        .map((it) => (this.vcu ? (this.vcu.model = it) : null));
      this.createForm(this.vcu);
    }
  }

  getModelAndFamily() {
    forkJoin({
      families: this.familyService.getAllFamily(),
      models: this.modelService.getAllModel()
    }).subscribe(({ families, models }) => {
      this.familyOptions = FamilyService.toItemList(families);
      this.modelOptions = ModelService.toItemList(models);
      this.getVcu();
    });
  }

  updateVcu() {
    this.vcuService.updateVcuNoProject(this.form.value).subscribe({
      next: (vcuResponse) => {
        this.vcu = VcuService.toVcu(vcuResponse);
        this.getVcu();
        this.showMessage("success", "Sucesso ao editar os dados da VCU");
      },
      error: (_) => {
        this.translocoService
          .selectTranslate("errorConection")
          .subscribe((value) => this.showMessage("error", value));
      },
    });
  }

  private showMessage(
    severity: "success" | "error" | "info" | "warn",
    summary: string
  ): void {
    this.messageService.clear();
    this.messageService.add({
      key: "toastVcu",
      severity,
      summary,
    });
  }

goToTelemetry(): void {
  this.router.navigate(['/vcu', this.vcu.id, 'telemetry']);
}

onPlanUpgraded(): void {
  this.loadPlanFeatures();
}

onTelemetryClick(): void {
  if (this.hasTelemetry) {
    this.goToTelemetry();
  } else {
    this.showProModal = true;
  }
}
}